<template>
  <div class="side-menu-wrapper">
    <slot></slot>
    <Menu ref="menu" v-show="!collapsed" :active-name="activeName" :open-names="openedNames" :mode="menuMode"
          :accordion="accordion" :theme="theme" width="auto" @on-select="handleSelect">
      <template v-for="item in menuList">
        <template v-if="item.children && item.children.length == 1">
          <router-link :to="{name:item.children[0].name}">

            <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
            <menu-item v-else :name="getNameOrHref(item, true)" :key="`menu-${item.children[0].name}`">
              <span>{{ showTitle(item.children[0]) }}</span></menu-item>
          </router-link>

        </template>
        <template v-else>
          <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
        </template>
      </template>
      <template>
        <Submenu name="1">
          <template slot="title">
            <!--<common-icon />      -->
            {{ $t('components.user.signOut')}}
          </template>
          <MenuItem name="1-1">
            <div>{{$t('components.user.signOut')}}</div>
          </MenuItem>
          <MenuItem name="1-2">
            <!--<common-icon />-->
            <div>中文</div>
          </MenuItem>
          <MenuItem name="1-3">
            <!--<common-icon />-->
            <div>English</div>
          </MenuItem>
        </Submenu>
      </template>
      <template>


      </template>

    </Menu>


    <!-- <div class="menu-collapsed" v-show="collapsed" :list="menuList"> -->

    <!--<router-link :to="'/authorityManagement/propsLimit'" >-->

    <!--</router-link>-->

    <!-- <div class="menu-collapsed" v-show="collapsed">
      <template v-for="item in menuList">
        <collapsed-menu v-if="item.children && item.children.length > 1" @on-click="handleSelect" hide-title :root-icon-size="rootIconSize" :icon-size="iconSize" :theme="theme" :parent-item="item" :key="`drop-menu-${item.name}`"></collapsed-menu>
        <Tooltip transfer v-else :content="showTitle(item.children && item.children[0] ? item.children[0] : item)" placement="right" :key="`drop-menu-${item.name}`">
          <a @click="handleSelect(getNameOrHref(item, true))" class="drop-menu-a" :style="{textAlign: 'center'}"><common-icon :size="rootIconSize" :color="textColor" :type="item.icon || (item.children && item.children[0].icon)"/></a>
        </Tooltip>
      </template>
    </div> -->
  </div>
</template>
<script>
  import SideMenuItem from './side-menu-item.vue'
  import CollapsedMenu from './collapsed-menu.vue'
  import {getUnion} from '@/libs/tools'
  import mixin from './mixin'
  import {mapActions} from 'vuex'
  import until from '@/js/until.js'

  export default {
    name: 'SideMenu',
    mixins: [mixin],
    components: {
      SideMenuItem,
      CollapsedMenu
    },
    props: {
      menuList: {
        type: Array,
        default() {
          return []
        }
      },
      collapsed: {
        type: Boolean
      },
      theme: {
        type: String,
        default: 'dark'
      },
      rootIconSize: {
        type: Number,
        default: 20
      },
      iconSize: {
        type: Number,
        default: 16
      },
      accordion: Boolean,
      activeName: {
        type: String,
        default: ''
      },
      openNames: {
        type: Array,
        default: () => []
      },
      menuMode: {
        type: String,
        default: 'vertical',
      },
    },
    data() {
      return {
        openedNames: []
      }
    },
    methods: {
      ...mapActions([
        'handleLogOut'
      ]),
      logout() {
        this.$http.loginOut().then(res => {
          this.$localStore.set('token', '');
          this.$localStore.set('login_uid', '');
          this.$localStore.set('login_username', '');
          this.$localStore.set('authList', '');
          this.$router.push({
            name: 'login'
          });
          // 清空权限的缓存
          this.$store.commit('SETPUBLICSIDEMENU', []);
        });
      },
      zh() {
        console.log("点击中文")
        this.$i18n.locale = 'zh-cn';
        this.$store.commit('SETLOCALE', 'zh-cn');
      },
      en() {
        this.$i18n.locale = 'en';
        this.$store.commit('SETLOCALE', 'en');
      },
      handleSelect(name) {
        this.$store.commit('SETSHOWBREADCRUMB', true); // 跳转时 设置默认显示面包屑导航

        if (name == '1-1') {
          this.logout()
        }
        if (name == '1-2') {
          this.zh()
        }
        if (name == '1-3') {
          this.en()
        }
        this.$emit('on-select', name);

      },
      updateOpen(){
        this.$refs.menu.updateOpened();
        this.$refs.menu.updateActiveName();
      },

      getOpenedNamesByActiveName(name) {
        if( until.phoneType() != 'PC'){
          document.activeElement.blur();
        }
        return this.$route.matched.map(item => item.name).filter(item => item !== name)
      },
      updateOpenName(name) {
        if (name == this.$config.homeName) this.openedNames = []
        else this.openedNames = this.getOpenedNamesByActiveName(name)
      },
    },
    computed: {
      textColor() {
        return this.theme == 'dark' ? '#fff' : '#495060'
      }
    },
    watch: {
      activeName(name,oldName) {
        if (this.accordion){
          this.openedNames = this.getOpenedNamesByActiveName(name);
        }else{
          this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))

        }
      },
      openNames(newNames) {
        this.openedNames = newNames
      },
      openedNames(newNames,oldName) {



        this.$nextTick(() => {
          this.$refs.menu.updateActiveName();
          if( until.phoneType() != 'PC'){

                if(document.getElementById('contentTop')){
                  document.getElementById('contentTop').click()
                }else {
                  this.$refs.menu.updateOpened();

                }


            //   if(this.$refs.menu.$children){
          //     this.$refs.menu.$children.forEach((item)=>{
          //       item.$children[0].opened=false;
          //       item.$children[0].active=false;
          //       document.activeElement.blur();
          //
          //
          //     })
          //
          //   }
          //
          }

          // this.$refs.menu.$children[1].opened=false;

          // this.$refs.menu.$chear
          if( until.phoneType() != 'PC'){
            // this.openedNames=[];
            // this.$refs.menu.$children.opened = false;
          }

        })
      },
      // menuList() {
      //   this.$nextTick(() => {
      //     const elSubTitle = document.querySelectorAll('.left-sider .ivu-menu-submenu');
      //     elSubTitle.forEach(elItem => {
      //       const elTitle = elItem.querySelector('.ivu-menu-submenu-title');
      //       if (elTitle) {
      //         elTitle.addEventListener('click', () => {
      //           if (elItem.classList && elItem.classList.contains('ivu-menu-opened') && window.innerWidth < 760) {
      //             this.openedNames = []
      //           }
      //         });
      //       }
      //     });
      //   });
      // },
    },
    mounted() {
      this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))

    }
  }
</script>
<style lang="less">
  @import './side-menu.less';
  /*.logOut{*/
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 0;*/
  /*width: 100%;*/
  /*height: 100%;*/
  /*padding:20px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/main/components/side-menu/side-menu.vue